import { configureOpenApiClients } from '../../api/configure';
import { entitlementGetCustomerEntitlements, entitlementRegisterDiscountAsync } from '../../api/v1';

export const useEntitlementApi = (token: string) => {
  configureOpenApiClients();

  const addEntitlement = async (data: { code: string }) => {
    const options = {
      headers: { authorization: 'Bearer ' + token },
      body: {
        code: data.code,
      },
    };
    return await entitlementRegisterDiscountAsync(options);
  };

  const getUserEntitlements = async () => {
    return await entitlementGetCustomerEntitlements({
      headers: { authorization: 'Bearer ' + token },
    });
  };

  return {
    addEntitlement,
    getUserEntitlements,
  };
};
